import { Loader2 } from 'lucide-react';
import { useId } from 'react';

import {
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@virtual-care/shadcn';
import { FieldMessage, useData } from '@virtual-care/ui';

export function SpecialitySelect<
  TF extends {
    state: any;
    handleChange: (value: string) => void;
  },
>({ field }: { field: TF }) {
  const id = useId();
  const specialitiesDataQuery = useData('GET /specialities', {
    page: 1,
    pageSize: 100,
  });

  return (
    <div className="space-y-2">
      <Label htmlFor={id}>Speciality</Label>
      <Select
        value={field.state.value}
        onValueChange={(value) => field.handleChange(value)}
      >
        <SelectTrigger id={id} className="w-full">
          <div className="flex items-center gap-x-1">
            {specialitiesDataQuery.isPending && (
              <Loader2 className="animate-spin" />
            )}
            <SelectValue placeholder="Select speciality" />
          </div>
        </SelectTrigger>
        <SelectContent>
          {specialitiesDataQuery.data?.records?.map((speciality) => (
            <SelectItem key={speciality.id} value={speciality.id}>
              {speciality.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <FieldMessage errors={field.state.meta.errors} />
    </div>
  );
}
